export default __webpack_public_path__ + "static/media/portalekran.d04c2ce3.png";